import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMainCategory, getSubCategories } from "../../services/CategoryService";

const initialState:any = {
   isLoading: false,
   error: null,
   mainCategory:[],
   subCategory:[],
   
};
export const fetchMainCategory:any= createAsyncThunk(
  "/dropdown-main-categories",
  async () => {
    const response = await getMainCategory();
    return response.data; 
  }
);
export const fetchSubCategory:any= createAsyncThunk(
  "/dropdown-sub-categories",
  async () => {
    const response = await getSubCategories();
    return response.data; 
  }
);
export const categorySlice = createSlice({
  name: "categorySlice",
  initialState,
  reducers: {
   
    emptyCategory: (state) => {
      state.mainCategory = [];
    },
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMainCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchMainCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mainCategory = action.payload; 
        
      })
      .addCase(fetchMainCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to main category details";
        console.error("Fetch main category details failed:", action.error);
      })
      .addCase(fetchSubCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchSubCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subCategory = action.payload; 
        
      })
      .addCase(fetchSubCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to sub  category  details";
        console.error("Fetch sub category details failed:", action.error);
      });
  },
});

// Export the action creator generated by createSlice
export const { emptyCart}: any =
  categorySlice.actions;

// Export the reducer function generated by createSlice
export default categorySlice.reducer;
